import React from 'react';

export default function TopKhuPhoCard({ data = [], isLoading = false, timeLabel = '' }) {
  const getRankBadgeStyle = (rank) => {
    switch (rank) {
      case 1:
        return 'bg-emerald-600 text-white font-bold shadow-xs';
      case 2:
        return 'bg-blue-600 text-white font-bold shadow-xs';
      case 3:
        return 'bg-indigo-600 text-white font-bold shadow-xs';
      default:
        return 'bg-gray-100 text-gray-600 font-semibold';
    }
  };

  return (
    <div className="bg-white rounded-lg p-4 md:p-5 shadow-xs border border-gray-200 h-full flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between mb-3 pb-2.5 border-b border-gray-100">
        <h3 className="text-xs md:text-sm font-bold text-gray-800 uppercase tracking-wider">
          Top khu phố ít phản ánh nhất {timeLabel ? `(${timeLabel})` : ''}
        </h3>
      </div>

      {/* Top Khu Pho List */}
      <div className="space-y-2 flex-1">
        {isLoading ? (
          Array.from({ length: 5 }).map((_, idx) => (
            <div
              key={idx}
              className="p-2.5 rounded-lg border border-gray-100 bg-gray-50/50 flex items-center justify-between animate-pulse"
            >
              <div className="flex items-center gap-2.5 min-w-0">
                <div className="w-5 h-5 rounded-md bg-gray-200" />
                <div className="w-24 h-3.5 bg-gray-200 rounded" />
              </div>
              <div className="flex items-center gap-2.5 flex-shrink-0">
                <div className="w-14 h-3.5 bg-gray-200 rounded" />
              </div>
            </div>
          ))
        ) : !data || data.length === 0 ? (
          <div className="flex items-center justify-center flex-1 py-8 text-xs md:text-sm text-gray-400 font-medium">
            Chưa có dữ liệu thống kê
          </div>
        ) : (
          data.map((item, index) => {
            const rank = item.rank || index + 1;
            return (
              <div
                key={item.name || rank}
                className="p-2.5 rounded-lg border border-gray-100 bg-gray-50/40 hover:bg-gray-50 flex items-center justify-between transition-colors"
              >
                <div className="flex items-center gap-2.5 min-w-0 flex-1 mr-2">
                  <span
                    className={`w-5 h-5 rounded-md flex items-center justify-center text-[11px] flex-shrink-0 ${getRankBadgeStyle(
                      rank
                    )}`}
                  >
                    {rank}
                  </span>
                  <span className="text-xs font-semibold text-gray-800 truncate" title={item.name}>
                    {item.name}
                  </span>
                </div>

                <div className="flex items-center gap-2.5 flex-shrink-0">
                  <span className="text-right text-xs font-semibold text-blue-600 bg-blue-50 px-2 py-0.5 rounded-md border border-blue-100 whitespace-nowrap">
                    {item.total} đơn
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
